import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="contenu" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-187" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-188" data-mp="yto92oc602jf">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-189" data-mp="kx13jx65c41w">
          <span aria-hidden="true" data-id="element-190" data-mp="pthokii1u2ar">📦 </span>Que contient le pack ARTS PRÊT™ ?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-191" data-mp="b4vbknfw9mmp">
          {packItems.map(item => <li key={item.title} className="flex flex-col rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-192" data-mp="fyg07ovll498">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-193" data-mp="74bdnhnhyezi">
                {item.emoji}
              </span>
              <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-194" data-mp="3odzpkct5e2j0">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-195" data-mp="3tb9mediv9ggv">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}